import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from 'src/shared/servies/meta.service';
import { TitleService } from 'src/shared/servies/title.service';
@Component({
  selector: 'app-elm',
  templateUrl: './elm.component.html',
  styleUrls: ['./elm.component.scss']
})
export class ELMComponent implements OnInit {

  constructor(
        

  ) { }

  ngOnInit(): void {
  }

}
